// Normalised geometry keeps the same artwork at every preview/print size.
// Decorations stay outside the document's content and verification areas.
export const CERTIFICATE_PALETTE = Object.freeze({ navy: '#2F509F', orange: '#F3A600', gold: '#FFCA00', cyan: '#67C3E8' })

export function certificateFrame({ width = 1122, height = 794, waveDepth = 0.13, border = 0.035 } = {}) {
    const w = width, h = height, t = h * waveDepth, b = w * border
    const curve = (left, mid, right) => `M0 ${left} C${w * .30} ${left - t * .6} ${w * .38} ${mid} ${w * .57} ${mid} S${w * .86} ${right - t * .5} ${w} ${right}`
    return [
        { fill: 'navy', d: `M0 0H${w}V${h}H0Z M${b} 0V${h - t * .7}H${w - b}V0Z`, rule: 'evenodd' },
        { fill: 'gold', d: `M0 ${h * .39}L${b} ${h * .36}V${h * .93}H0Z M${w - b} ${h * .19}L${w} ${h * .22}V${h * .61}L${w - b} ${h * .64}Z` },
        { fill: 'cyan', d: `${curve(t * 1.42, t * .72, t * 1.30)} L${w} 0H0Z` },
        { fill: 'gold', d: `${curve(t * .72, t * 1.12, t * .50)} L${w} 0H0Z` },
        { fill: 'orange', d: `${curve(t * .28, t * .95, t * .16)} L${w} 0H0Z` },
        { fill: 'navy', d: `${curve(t * .12, t * .72, t * .03)} L${w} 0H0Z` },
        { fill: 'cyan', d: `M0 ${h * .895} C${w * .32} ${h * .89} ${w * .45} ${h * .985} ${w} ${h * .935}V${h}H0Z` },
        { fill: 'orange', d: `M0 ${h * .88} C${w * .32} ${h * .91} ${w * .56} ${h * .985} ${w} ${h * .93}V${h}H0Z` },
        { fill: 'gold', d: `M0 ${h * .865} C${w * .35} ${h * .90} ${w * .57} ${h * .965} ${w} ${h * .92}V${h * .968} C${w * .55} ${h * 1.015} ${w * .27} ${h * .925} 0 ${h * .91}Z` }
    ]
}
